import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCesium from 'vue-cesium';
import 'cesium/Widgets/widgets.css';
import Global from '../src/components/Global'; /*阿里自适应适配*/
/*import 'lib-flexible'*/ import 'amfe-flexible/index.js';
import x2js from 'x2js';

import store from './store';
import db from './utils/localstorage';
import VueApexCharts from 'vue-apexcharts';
import './utils/install';
// axios.defaults.withCredentials = true
import './assets/icon/iconfont.css';
import './assets/css/commonBj.css';

import { Loading } from 'element-ui';
import AFTableColumn from 'af-table-column';
import { Base64, fromBase64 } from 'js-base64';

Vue.use(VueCesium, {
  // cesiumPath 是指引用的Cesium.js路径，如
  // 项目本地的Cesium Build包，vue项目需要将Cesium Build包放static目录：
  cesiumPath: './Cesium/Cesium.js',
  // 个人在线Cesium Build包：
  // cesiumPath: 'https://zouyaoji.top/vue-cesium/statics/Cesium/Cesium.js'
  // 个人在线SuperMap Cesium Build包（在官方基础上二次开发出来的）：
  // cesiumPath: 'https://zouyaoji.top/vue-cesium/statics/SuperMapCesium/Cesium.js'
  // 官方在线Cesium Build包，有CDN加速，推荐用这个：
  // cesiumPath: 'https://unpkg.com/cesium/Build/Cesium/Cesium.js',
  // 指定Cesium.Ion.defaultAccessToken，使用Cesium ion的数据源需要到https://cesium.com/ion/申请一个账户，获取Access Token。不指定的话可能导致 Cesium 在线影像加载不了
  // accessToken: ''
});
/** 权限指令,对按钮权限的控制 **/
Vue.directive('has', {
  bind: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      el.style.display = 'none';
    }
  },
});
// 权限检查方法（且把该方法添加到vue原型中）
Vue.prototype.$_has = function(value) {
  let isExist = false;
  // 从浏览器缓存中获取权限数组（该数组在登入成功后拉取用户的权限信息时保存在浏览器的缓存中）
  var buttonpermsStr = sessionStorage.getItem('authority');
  if (buttonpermsStr === undefined || buttonpermsStr == null) {
    return false;
  }
  if (buttonpermsStr.indexOf(value) > -1) {
    // 若在按钮中定义的权限字段能在后端返回的权限数组中能找到，则该按钮可显示
    isExist = true;
  }
  return isExist;
};
Vue.prototype.$x2js = new x2js();
//axios.defaults.baseURL = 'http://192.168.10.201:8888';  /*内网地址*/
// axios.defaults.baseURL = window.global_config.BASE_URL;
axios.defaults.baseURL = '/';
axios.interceptors.request.use((config) => {
  const sessionId = sessionStorage.getItem('sessionId');
  config.headers.sessionId = sessionId;
  return config;
});

//时间过滤器
function formatDate(date, fmt) {
  date = new Date(date);
  if (typeof fmt === 'undefined') {
    fmt = 'yyyy-MM-dd HH:mm:ss';
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
    }
  }
  return fmt;
}

//定义一个时间过滤器
Vue.filter('FormatDate', function(date, fmt) {
  return formatDate(date, fmt);
});

let loading;
//内存中正在请求的数量
let loadingNum = 0;
function startLoading() {
  if (loadingNum == 0) {
    loading = Loading.service({
      lock: true,
      background: 'rgba(255,255,255,0.2)',
    });
  }
  //请求数量加1
  loadingNum++;
}
function endLoading() {
  //请求数量减1
  loadingNum--;
  if (loadingNum <= 0) {
    loading.close();
  }
}

//请求数据拦截器
axios.interceptors.request.use(
  (request) => {
    startLoading();
    return request;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 响应拦截器
axios.interceptors.response.use(
  (response) => {
    endLoading();
    const code = response.data.code;
    if (code === 401 || code === 402) {
      // 返回401，清除token信息并跳转到登录页面
      sessionStorage.removeItem('sessionId');
      router.replace({
        path: '/login',
      });
      return Promise.reject(response.data);
    }
    return response;
  },
  (error) => {
    endLoading();
    if (error.response) {
      // 返回接口返回的错误信息
      return Promise.reject(error.response.data);
    }
  }
);
Vue.use(AFTableColumn);
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.use(db);
Vue.use(VueApexCharts);
Vue.use(Base64);
Vue.component('apexchart', VueApexCharts);

Vue.prototype.typelist = Global.typelist;
Vue.prototype.genUUID = () => {
  return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
/*创建和挂载vue根实例 让整个应用都有路由功能*/
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
